/* NestnGo: mobile sticky add-to-cart */
(function () {
  function init() {
    var form = document.querySelector('product-form');
    if (!form) return;
    var submit = form.querySelector('.product-form__submit');
    if (!submit) return;

    var titleEl = document.querySelector('.product__title h1') || document.querySelector('.product__title');
    var saleEl = document.querySelector('.product .price__sale .price-item--sale');
    var regEl = document.querySelector('.product .price__regular .price-item--regular');
    var wasEl = document.querySelector('.product .price__sale s.price-item--regular');

    var bar = document.createElement('div');
    bar.className = 'nng-sticky-atc';
    var priceHtml = '';
    if (saleEl) {
      priceHtml = (wasEl ? '<s>' + wasEl.textContent.trim() + '</s>' : '') + saleEl.textContent.trim();
    } else if (regEl) {
      priceHtml = regEl.textContent.trim();
    }
    bar.innerHTML =
      '<div class="nng-sticky-atc__info">' +
      '<span class="nng-sticky-atc__title">' + (titleEl ? titleEl.textContent.trim() : '') + '</span>' +
      '<span class="nng-sticky-atc__price">' + priceHtml + '</span>' +
      '</div>' +
      '<button type="button" class="nng-sticky-atc__btn"></button>';
    document.body.appendChild(bar);

    var btn = bar.querySelector('.nng-sticky-atc__btn');
    function syncButton() {
      var label = submit.querySelector('span');
      btn.textContent = label ? label.textContent.trim() : 'Add to Bag';
      btn.disabled = submit.disabled;
    }
    syncButton();
    new MutationObserver(syncButton).observe(submit, { attributes: true, childList: true, subtree: true });

    btn.addEventListener('click', function () {
      submit.click();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', passed);
      }, { threshold: 0 }).observe(submit);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
